import { AppDispatch } from '../../store';
import { setLoading, setError, setSuccess } from '../app/appSlice';
import { AdController, AdPayload } from '../../api/controllers/ad.controller';
import { setAd, setAds } from './adsSlice';

export const getAds = (payload: { adset_id: string }) => async (dispatch: AppDispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setError(''));

    const response = await AdController.getAds(payload);

    dispatch(setAds(response.data));
    dispatch(setSuccess(true));
  } catch (error: any) {
    dispatch(setError('Fetching ads failed. please try it again later'));
    dispatch(setSuccess(false));
  } finally {
    dispatch(setLoading(false));
  }
};

export const getAd = (payload: { id: string }) => async (dispatch: AppDispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setError(''));

    const response = await AdController.getAd(payload);

    dispatch(setAd(response.data));
    dispatch(setSuccess(true));
  } catch (error: any) {
    dispatch(setError('Fetching ads failed. please try it again later'));
    dispatch(setSuccess(false));
  } finally {
    dispatch(setLoading(false));
  }
};

export const createAd = (payload: AdPayload) => async (dispatch: AppDispatch) => {
  try {
    dispatch(setError(''));

    const response = await AdController.createAd(payload);

    dispatch(setAd(response.data));
    dispatch(setSuccess(true));
    return response.data;
  } catch (error: any) {
    dispatch(setError('Creating a new ad failed. please try it again later'));
    dispatch(setSuccess(false));
    return null;
  }
};
